import { createNotification } from './notification';

export const NOTIFICATIONS_ADD = 'NOTIFICATIONS_ADD';
export const NOTIFICATIONS_REMOVE = 'NOTIFICATIONS_REMOVE';
export const NOTIFICATIONS_REPLACE = 'NOTIFICATIONS_REPLACE';

export const addNotification =
  notification => ({
    type: NOTIFICATIONS_ADD,
    notification: createNotification(notification),
  });

export const removeNotification =
  notification => ({
    type: NOTIFICATIONS_REMOVE,
    notification,
  });

export const replaceNotification =
  (notification, newNotification) => ({
    type: NOTIFICATIONS_REPLACE,
    notification,
    newNotification: createNotification(newNotification),
  });
